import { useState } from 'react';

export function useSelectByTypeList<T extends string>(type: T) {
  const [list, setList] = useState<number[]>([]);

  const addItem = (id: number, addType: T) => {
    if (addType === type) {
      if (list.indexOf(id) !== -1) {
        setList((prevState) => prevState.filter((item) => item !== id));
      } else {
        setList((prevState) => prevState.concat(id));
      }
    }
  };

  const clear = () => {
    setList([]);
  };

  const selectAll = (ids: number[], addType: T) => {
    if (addType === type) {
      setList(ids);
    }
  };

  return { list, addItem, selectAll, clear, currentStatus: type };
}
